import {request} from 'helpers/services/utils/request';
import {PUT} from 'helpers/services/constants/API_CONSTANTS';
import {PUT_STORE_APPEARANCE} from 'helpers/services/constants/API_ENDPOINTS';

export const putStoreAppearanceApi = async (locationId, data) => {
  return request(PUT, PUT_STORE_APPEARANCE(locationId), {data});
};

export default putStoreAppearanceApi;
